<template>
  <div class="enter-infor-container">
    <div v-if="enterType == 1" class="enter-infor">
      <div class="header">
        <div class="left">
          <div class="left-icon-container">
            <img class="left-icon" :src="require('@/assets/cztc.png')" />
          </div>

          <div class="center">
            <p class="center-title">{{ orderName }}</p>
            <p class="center-desc">{{ orderInfor }}</p>
          </div>
        </div>

        <div class="right">
          <p class="right-title">¥{{ payMomey }}</p>
        </div>
      </div>

      <div class="center-line"></div>

      <div>
        <div class="footer" v-if="deviceMoney > 0">
          <div class="footer-left">押金金额</div>
          <div class="footer-right">¥{{ deviceMoney }}</div>
        </div>

        <div class="footer">
          <div class="footer-left">总金额</div>
          <div class="footer-right">¥{{ allPayMomey }}</div>
        </div>
      </div>
    </div>

    <div v-else class="enter-infor">
      <div class="header">
        <div class="left">
          <div class="left-icon-container">
            <img class="left-icon" :src="require('@/assets/yjdd.png')" />
          </div>

          <div class="center">
            <p class="center-title">设备押金</p>
          </div>
        </div>

        <div class="right">
          <p class="right-title">¥{{ deviceMoney }}</p>
        </div>
      </div>

      <div class="center-line"></div>

      <div>
        <div class="footer">
          <div class="footer-left">总金额</div>
          <div class="footer-right">¥{{ allPayMomey }}</div>
        </div>
      </div>
    </div>

    <div class="click-content">
      <wx-open-launch-weapp id="launch-btn" appid="wxd3188aada6d8ace9">
      </wx-open-launch-weapp>
    </div>
  </div>
</template>

<script>
import { getWXAuthInfor, getOrderListDetail } from "@/api/home";
import { Toast } from "vant";
import { Dialog } from "vant";

export default {
  data() {
    return {
      deviceMoney: 0, //设备押金
      sn: "", //设备SN
      terminalId: "", //设备ID
      enterType: 1, //1 普通支付 2:押金支付
      orderName: "", //套餐名称
      orderInfor: "", //套餐描述
      allPayMomey: 0, //总支付金额
      payMomey: 0, //支付金额
      timeCount: 5, //
      isenterAuth: this.$route.query.isenterAuth || "0", //是否跳转到授权界面
      
      discountAmount: 0,//优惠券金额
      claimRecordId:"",//优惠券ID
    };
  },
  mounted() {
    ///设备ID
    this.terminalId = this.$route.query.terminalId;

    ///设备SN
    this.sn = this.$route.query.sn;
    ///套餐ID
    let packageId = this.$route.query.packageId;
    ///是否帮别人购买
    let isHelpOtherPurchase = this.$route.query.isHelpOtherPurchase;
    //设备押金
    this.deviceMoney = this.$route.query.deviceMoney || 0;
    //支付金额
    this.payMomey = this.$route.query.payMomey || 0;

    ///套餐名称
    this.orderName = this.$route.query.orderName;
    ///套餐描述
    this.orderInfor = this.$route.query.orderInfor;

    // this.discountAmount = this.$route.query.discountAmount;
    // this.claimRecordId = this.$route.query.claimRecordId;


    this.allPayMomey = (
      (this.payMomey * 100 + this.deviceMoney * 100) /
      100
    ).toFixed(2);

    let extraData = {
      cookie: document.cookie,
      terminalId: this.terminalId,
      payMomey: this.allPayMomey,
    };

    if (packageId) {
      ///套餐支付
      this.enterType = 1;
      extraData.packageId = packageId;
      extraData.isHelpOtherPurchase = isHelpOtherPurchase;
    } else {
      ///押金支付
      this.enterType = 2;
    }

    let launchBtn = document.getElementById("launch-btn");
    launchBtn.style.width = "90%"; 
    launchBtn.style.display = "block";

    let myPath = `pages/pay/index`;
    launchBtn.setAttribute("path", myPath);
    launchBtn.setAttribute("extra-data", JSON.stringify(extraData));
    // launchBtn.setAttribute("env-version", "trial");

    // 清空原有内容
    launchBtn.innerHTML = "";
    // 创建 script 标签
    const script = document.createElement("script");
    script.type = "text/wxtag-template";
    script.textContent = `
    <style>
      .btn {
        background-color: ${this.appData.merThemeColor};
        border-radius: 8px;
        color: white;
        font-size: 16px;
        height: 50px;
        padding: 0 15px;
        white-space: nowrap;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        width: 100%; 
        box-sizing: border-box;
      }
    </style>
    <button class="btn">前往支付</button>
  `;
    launchBtn.appendChild(script);

    //注册监听
    document.addEventListener("visibilitychange", this.handleVisibilityChange);

    //配置微信授权
    this.uppdateWXConfigAction();
  },

  //移除监听
  beforeDestroy() {
    this.stopPolling();
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
  },

  methods: {
    uppdateWXConfigAction() {
      ///加载中
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      getWXAuthInfor().then((res) => {
        this.$wx.config({
          debug: false,
          appId: res.appId, 
          timestamp: res.timestamp, 
          nonceStr: res.noncestr, 
          signature: res.signature, 
          jsApiList: ["scanQRCode"], 
          openTagList: ["wx-open-launch-weapp"], 
        });

        this.$wx.ready(() => {
          this.$toast.clear();
        });
      });
    },

    handleVisibilityChange() {
      if (document.visibilityState === "visible") {
        this.getOrderStatus();
      }
    },

    async getOrderStatus() {
      let flage = 0;
      let finished = false; // ✅ 标记是否已完成

      while (flage <= this.timeCount) {
        flage++;
        try {
          const res = await getOrderListDetail();
          const { canPoll, payStatus } = res;

          // ✅ 优先判断支付状态
          if (payStatus === "C") {
            this.stopPolling();
            finished = true;

            if (this.isenterAuth === "1") {
              this.$store.dispatch("updateDeviceID", this.terminalId);
              this.uni.navigateTo("/home/auth?sn=" + this.sn + "&isFirst=1");
            } else {
              this.uni.reLaunch("/home/index");
            }
            break; // ✅ 跳出循环
          } else if (payStatus === "E") {
            this.stopPolling();
            finished = true;
            break;
          }

          // ✅ 不继续轮询，退出
          if (!canPoll) {
            this.stopPolling();
            finished = true;
            break;
          }

          // ✅ 未支付/支付中才提示
          Toast.loading({
            message: "请稍等，支付结果查询中",
            forbidClick: true,
            duration: 0,
          });

          await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
          await new Promise((resolve) => setTimeout(resolve, 1000));
        }
      }

      // ✅ 循环结束后再统一判断是否需要弹窗
      if (!finished && flage >= this.timeCount) {
        this.stopPolling();
        Dialog.confirm({
          title: "",
          message: "未获取到支付结果，如已支付请重新发起查询",
          confirmButtonText: "重新查询",
          cancelButtonText: "关闭",
          confirmButtonColor: this.appData.merThemeColor,
          cancelButtonColor: "#999999",
        })
          .then(() => {
            this.getOrderStatus(); // 重新开始
          })
          .catch(() => {});
      }
    },

    stopPolling() {
      Toast.clear();
    },
  },
};
</script>

<style lang="less" scoped>
.enter-infor-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #f2f2f2;

  .enter-infor {
    display: flex;
    flex-direction: column;

    background-color: white;
    margin: 32px;
    border-radius: 20px;
    width: calc(100% - 64px);

    .header {
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: space-between;
      padding: 24px;

      .left {
        display: flex;

        .left-icon-container {
          display: flex;
          .left-icon {
            width: 132px;
            height: 132px;
          }
        }

        .center {
          display: flex;
          flex-direction: column;
          margin-left: 24px;

          .center-title {
            font-size: 30px;
            color: #000;
            font-weight: bold;
            margin-bottom: 10px;
          }

          .center-desc {
            font-size: 26px;
            color: #848992;
            margin-top: 8px;
          }
        }
      }

      .right {
        display: flex;
        .right-title {
          font-size: 30px;
          color: #000;
          font-weight: bold;
        }
      }
    }

    .center-line {
      width: 100%;
      height: 2px;
      background-color: #f5f6fa;
      margin-bottom: 20px;
    }

    .footer {
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      margin-top: 24px;
      padding: 0 24px;

      .footer-left {
        font-size: 26px;
        color: #848992;
      }

      .footer-right {
        font-size: 26px;
        color: #000;
      }
    }
  }

  .click-content {
    display: flex;
    justify-content: center;
    align-content: center;
    width: calc(100% - 64px);
    margin: 100px auto 0;
  }
}
</style>
